import api from '@/api'
import products from '@/api/apiSferest/services/products'

export const getList = ({ commit, state, getters, dispatch }) => {
  dispatch('loading')
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      let params = {
        ...getters['query'],
        sort: state.search.sort || 'id',
        limit: state.search.limit
      }
      products.list(params)
      .then((res) => {
        commit('list/SET_LIST', res.data)
        commit('search/SET_MORE', res.headers['x-next-page'])
        dispatch('loaded')
        resolve(res.data)
      }, err => {
        reject(err)
        dispatch('loaded')
      })
    })
  })
}

export const getMore = ({ commit, state, dispatch }) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      api.apiSferest.get(state.search.more, { data: {} })
      .then((res) => {
        if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
          reject(new Error('Error de conexión'))
          return
        }
        commit('list/ADD_TO_LIST', res.data)
        commit('search/SET_MORE', res.headers['x-next-page'])
        resolve(res.data)
      })
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_VENDORCODE', undefined)
    commit('SET_DESCRIPTION', undefined)
    commit('SET_PRICEBATCH', undefined)
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}

/**
 * Remove products
 * @param {Array} selected - List of product objects
 */
export const remove = ({ commit, dispatch }, selected) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      products.remove(selected.map(x => x.id))
      .then((res) => {
        resolve(res)
      })
    })
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
